
let language = {

    MOVE_FILE_MODAL_CREATE_TO_TITLE: "创建:",
    MOVE_FILE_MODAL_FOLDER_NAME_PLACEHOLDER: "文件夹名称",

    MOVE_FILE_MODAL_ROOT_CATALOG_NAME: "文件库",
    
    // 
    MOVE_FILE_MODAL_CONFIRM_BTN: "确认",
    MOVE_FILE_MODAL_CANCEL_BTN: "取消",
    MOVE_FILE_MODAL_MOVE_BTN: "移动",
    MOVE_FILE_MODAL_CREATE_NEW_FOLDER_BTN: "创建新的文件夹",
    
    // 
    MOVE_FILE_MODAL_MOVE_SUCCESS_TIP: "移动成功"
};

export { language }